<ng-container *transloco="let t" class="container">
  <div class="p-2">
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
      </button>
    </div>
    <div class="modal-body">
      <p class="pb-3">{{ text }}</p>
      @if (dispayTextArea) {
        <textarea type="text" class="form-control" id="textArea" rows="3" [placeholder]="textAreaPlaceholder"
                  [ngModel]="textAreaContent" (ngModelChange)="textAreaInput($event)"></textarea>
      }
    </div>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <div class="me-3">
          <app-button (onClick)="onDismissClick()" [label]="dismissButtonTitle ?? t('app.common.cancel')"
                      [btnClass]="'btn-grey text-uppercase'"></app-button>
        </div>
        <app-button (onClick)="onConfirmClick()" [label]="confirmButtonTitle ?? t('app.common.confirm')"
                    [btnClass]="'btn-primary-red text-uppercase'"></app-button>
      </div>
    </div>
  </div>
</ng-container>
